import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Header from '@/components/layout/header'
import Footer from '@/components/layout/footer'
import Link from '@/components/ui/link'
import Button from '@/components/ui/button'

export default function NotFound() {
  const { t } = useTranslation()

  useEffect(() => {
    const meta = document.createElement('meta')
    meta.name = 'prerender-status-code'
    meta.content = '404'
    document.head.appendChild(meta)
    return () => {
      document.head.removeChild(meta)
    }
  }, [])

  return (
    <>
      <title>{t('notFound.title')}</title>
      <meta name="robots" content="noindex,follow" />
      <Header />
      <main className="min-h-[70vh] flex items-center justify-center px-5 py-32 text-center">
        <div className="max-w-xl">
          <p className="font-display text-primary text-label-md uppercase tracking-widest mb-4">
            404
          </p>
          <h1 className="font-display text-3xl md:text-5xl font-extrabold tracking-tighter text-on-surface mb-6">
            {t('notFound.heading')}
          </h1>
          <p className="font-body text-on-surface-variant mb-8">{t('notFound.description')}</p>
          <Link href="/">
            <Button variant="gradient" size="md">
              {t('notFound.cta')}
            </Button>
          </Link>
        </div>
      </main>
      <Footer />
    </>
  )
}
